// 顧客宛文書のファイルダウンロード処理
import axios from '../../axios';
import { fileDownload } from '../../FileDownload';
import { KWANKGM00240A02 } from '../../const/api_modules';
import { content_type } from '../../Const';

/**
 * 顧客宛文書のファイルダウンロード
 * @param number doc_id 顧客宛文書のID
 * @param React.Dispatch setIsLoading ローディング操作メソッド（必須）
 * @param boolean need_pdf_open PDFを別タブで開く必要があるか（true=別タブで開く）
 */
export const CustomerDocumentFileDownload = async (
  doc_id: number,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  need_pdf_open: boolean,
) => {
  try {
    setIsLoading(true);

    // 共通APIから顧客宛文書をGETする
    const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
      params: {
        module_name : KWANKGM00240A02,
        is_json : false,
        reception_id : '',
        reception_cd : null,
        detail : [
          { id: 0, name: 'id', value: doc_id }
        ],
      },
      responseType: 'arraybuffer',
    });

    // PDFを別タブに開く画面仕様であり、ファイルタイプがPDFの場合は別タブにファイルを開く
    if (need_pdf_open && (response.headers['content-type'] === content_type.app_pdf || response.headers['content-type'] === content_type.pdf)) {
      const arr = new Uint8Array(response.data);
      const blob = new Blob([arr], { type: content_type.app_pdf });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } else {
      // それ以外の場合はファイルをダウンロードする
      fileDownload(response.data, response.headers['content-disposition'], response.headers['content-type']);
    }
  } catch (error) {
    console.error(error.response.data.message);
    alert(error.response.data.message);
  } finally {
    setIsLoading(false);
  }
};
